import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    {...props}
    fill="none"
    stroke="none">
    <Path
      stroke={props.fill || '#fff'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.021 1.09v4.34M33.89 6.77l-3.08 3.06M6.201 6.77l3.08 3.06M39.23 20.64h-4.34M4.711 20.64H.371M33.89 34.22l-3.08-3.06M6.201 34.888l3.08-3.06M20.021 40.191v-4.34"
    />
    <Path
      fill={props.fill || '#fff'}
      d="M19.68 31.501c5.954 0 10.78-4.786 10.78-10.69s-4.826-10.69-10.78-10.69c-5.953 0-10.78 4.786-10.78 10.69s4.827 10.69 10.78 10.69Z"
    />
  </Svg>
);
export default SvgComponent;
